<template>
	<router-view :key="key" />
</template>
<script>
import { getRouteTabCacheKey } from '@/utils/routeTab'

export default {
	name: 'RouteView',
	props: {
		keepAlive: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		key() {
			return getRouteTabCacheKey(this.$route, this.$store.state.multiTab.pages)
		}
	}
}
</script>
